class ResponseTransformer {
  static error(error) {
    return {
      status: error.status,
      title: error["data"]["hydra:title"],
      description: error["data"]["hydra:description"] || error.data.message,
      violations: error["data"]["violations"] || []
    }
  }
}

export default ResponseTransformer
